export default "__VITE_ASSET__BIZdSeZN__"